import {ref} from "vue";

export default function useSharedData() {
    const itemColor = ref("brown lighten-4");
    const itemColorHex = ref("#D7CCC8");
    const cardBackgroundColor = ref('#FAFAFA');

    const inputColor = ref("teal");
    const backgroundColor = ref("grey lighten-4");

    const legendChipElevation = ref(15);
    const tableElevation = ref(24);
    const chipElevation = ref(24);

    const total = ref(0);
    const totalPages = ref(0);
    const sortBy = ref("");
    const descending = ref(true);
    const page = ref(1);
    const pageCount = ref(0);
    const itemsPerPage = ref(20);
    const loading = ref(false);
    const sheet = ref(true);
    const filter = ref({});
    const paginationListLength = ref([5, 10, 15, 20, 25, 30, 35, 40, 45, 50]);
    const overlay = ref(false);
    const overlayOpacity = 0.9;
    const rightDrawer = ref(false);
    const dialog = ref(true);
    const selectedOne = ref({id: null});
    const selected = ref([]);

    return {
        itemColor,
        itemColorHex,
        cardBackgroundColor,

        inputColor,
        backgroundColor,

        legendChipElevation,
        tableElevation,
        chipElevation,

        total,
        totalPages,
        sortBy,
        descending,
        page,
        pageCount,
        loading,
        sheet,
        filter,
        paginationListLength,
        itemsPerPage,
        overlay,
        overlayOpacity,
        rightDrawer,
        dialog,
        selectedOne,
        selected,
    };
}
